export const isPathSelected = (urlPath, currentPathname) => {
  if (!urlPath) return false;
  if (urlPath === "/") return currentPathname === "/";
  return currentPathname === urlPath || currentPathname.startsWith(`${urlPath}/`);
};

const hasChildItems = (menuItem) => Array.isArray(menuItem?.children) && menuItem.children.length > 0;

export const buildHeaderMenuItems = ({
  items,
  pathname,
  search = '',
  selectedWaterSystem,
  history,
  setShowSystemSelectModal,
  triggerCsvDownload,

}) => {
  const mapItems = (menuItems, isChild = false) => {
    return menuItems.map((item) => {
      const hasChildren = hasChildItems(item);
      const childrenHaveChildren = hasChildren && item.children.some(hasChildItems);
      const mappedChildren = hasChildren ? mapItems(item.children, true) : [];
      const resolvedUrl = selectedWaterSystem?.systemId && item.url_route
        ? item.url_route.replace("%systemId%", encodeURIComponent(selectedWaterSystem.systemId))
        : item.url_route;
      const homeRouteWithSearch = resolvedUrl === "/water-system-home" && search && !resolvedUrl.includes("?")
        ? `${resolvedUrl}${search}`
        : resolvedUrl;
      const isCurrentSelected = isPathSelected(resolvedUrl, pathname)
        || mappedChildren.some((child) => child.isSelected);

      let actionUrl = resolvedUrl
        ? {
            url: homeRouteWithSearch,
            openInNewTab: item.route_option === "newTab",
          }
        : null;
      let actionFunction = null;
      let actionFunctionUrl = null;

      if (item.route_option === "csvDownload") {
        actionUrl = null;
        actionFunction = triggerCsvDownload;
      }

      if (item.use_react_routing && resolvedUrl) {
        actionUrl = null;
        if (item.selected_system_required_before_routing && !selectedWaterSystem) {
          actionFunction = () => {
            setShowSystemSelectModal(true);
          };
        } else {
          actionFunctionUrl = {
            url: homeRouteWithSearch,
            skipHandleEvent: true,
            openInNewTab: item.route_option === "newTab",
            actionFunction: (e) => {
              const isPlainLeftClick = e
                && e.button === 0
                && !e.metaKey
                && !e.ctrlKey
                && !e.shiftKey
                && !e.altKey;

              if (!isPlainLeftClick) return;

              e?.preventDefault?.();
              e?.stopPropagation?.();
              history.push(homeRouteWithSearch);
            },
          };
        }
      }

      if (item.selected_system_required_before_routing && !selectedWaterSystem) {
        actionUrl = null;
        actionFunctionUrl = null;
        actionFunction = () => {
          setShowSystemSelectModal(true);
        };
      }

      if (hasChildren) {
        return {
          title: item.label.toUpperCase(),
          isSelected: isCurrentSelected,
          actionMenu: mappedChildren,
          childrenMenuType: childrenHaveChildren ? "mega-menu" : "flyout",
        };
      }

      if (actionFunction) {
        return {
          title: isChild ? item.label : item.label.toUpperCase(),
          isSelected: isCurrentSelected,
          actionFunction,
        };
      }

      if (actionFunctionUrl) {
        return {
          title: isChild ? item.label : item.label.toUpperCase(),
          isSelected: isCurrentSelected,
          actionFunctionUrl,
        };
      }

      return {
        title: isChild ? item.label : item.label.toUpperCase(),
        isSelected: isCurrentSelected,
        actionUrl: actionUrl || { url: "/" },
      };
    });
  };

  return mapItems(Array.isArray(items) ? items : []);
};
